<template>
  <section
    id="hero"
    class="ml-6 mr-6"
  >
    <!--
    :src="require(`@/assets/images/water/RO_faucet_IMG_5498-10.JPG`)"
        :aspect-ratio="4/3"
    -->
    <v-container class="grey lighten-5">
      <span class="trace">Neighborhood.vue</span>

      <v-row>
        <v-col
          md="8"
          offset-md="2"
        >
          <h3>Water Protectors Neighborhood Program...</h3>
          <p class="mt-2">
            Past water studies have shown that neighborhoods tend to have similar water safety and quality characteristics.  So we at Water Protectors thought that it might also be good if we focused on a few key Truro neighborhoods at the same time as helping individual residents.
          </p>
          <!--
          <v-img
            :src="require(`@/assets/images/water/RO_faucet_IMG_5498-10.jpg`)"
            max-width=800
            class="mx-10"
          >
          </v-img>
          -->
          <p class="mt-2">
            One way we plan to do this is to help make water testing in the neighborhood easy and cheap to do.  And then encourage residents to get a water test.  In addition to the resident receiving the test results, the water information would add to a neighborhood-wide database, so that the neighborhood itself can be more fully evaluated.</p>
          <p class="mt-2">
            Eventually, with enough test data, the neighborhood can be professionally evaluated by a hyrologist, and that evaluation can be shared with all participating neighbors online.</p>
          <p class="mt-2">
            If the neighborhood is retested every so often, then water quality trends can be spotted earlier than usual.  This might detect problems such as a malfunctioning septic system, or the impact of new sources of nitrates and other contaminants near the neighborhood.</p>

          <h4>More Information Coming Soon</h4>
          <p class="mt-2">
            Please bear with us as our Water Protector volunteers work to flesh out the details of this program.  We have more worthy programs than volunteer hours, so it takes a little time to get a new program up and going.  So please stay tuned.</p>

          <!--
          <v-img
            :src="require(`@/assets/images/water/RO_basement_IMG_5496-10.jpg`)"
            max-width=800
            class="mx-10"
          >
          </v-img>
          <p class="mt-2">
          The reverse osmosis process was invented by the US Navy to put drinking water on submarines.  It works by using the water pressure on the well water side of the RO and forces the water across the semi-permeable RO membrane, leaving contaminants behind in the reject stream<span v-if="youTube">*</span>.  This is a slow process, which is why the purified water is then fed to a small storage tank<span v-if="youTube">**</span>, so when the filtered water faucet at the sink is used, it doesn't run out of water unless run for a while.
          </p>
          <p class="mt-2">
          The RO equipment easily fits under most kitchen sinks.  And as shown in the photo above, it can also be installed in a basement room directly below the kitchen, with the filtered water piped up through the floor under the sink, provided there is clear access.  Either location works well.
          </p>

          <h3>Benefits</h3>
          <p class="mt-2">
            In addition to contaminants being removed, water from the RO filtration system has a very clean taste.  It can be compared to bottled water.  Below is a photo of a taste test in progress.  "Ted" started drinking more water as soon as his bowl started to be filled with clean-tasting water.
          </p>
          <v-img
            :src="require(`@/assets/images/water/Ted_Bluedrop_IMG_5511.png`)"
            max-width=800
            class="mb-2 mx-10"
          >
          </v-img>

          <h3>Water Protectors Bluedrop Program</h3>

          <p class="mt-2">
            The Water Protectors group has negotiated a volume pricing arrangement with
            <a
            href="http://www.bluedropwater.com/"
            target="_blank"
            >Bluedrop Water</a> to install and service RO systems in Truro.  Bluedrop is a leading supplier of engineered water filtration systems in New England.  Through the program an RO system can be installed with a 15% discount from Bluedrop.  As we all know, it is sometimes difficult to get experts to travel to Truro.  Bluedrop hopes that by working together with CAT it can gain enough customers in Truro so that there is a technician in Truro frequently, thereby providing a high level of service.
          </p>
          <p class="mt-2">
            This program was inspired by the Outer Cape Solarize program managed by the Truro Energy Committee where in the past two years almost 100 Truro residents were able to obtain solar photovoltaic systems at a negotiated lower cost.
          </p>
          <div v-if="youTube">
            <hr>
            <p class="mt-2">
            * Here's a 4&half; minute YouTube video
            <a
            href="https://www.youtube.com/watch?v=qlexW47DtWA"
            target="_blank"
            >How Does a Reverse Osmosis Drinking Water System Work?</a>
            </p>

            <p class="mt-2">
            ** Here's a slightly technical YouTube video <a
            href="https://www.youtube.com/watch?v=2zgC8xED3_M"
            target="_blank"
            >What is a Reverse Osmosis Tank and How Does it Work?</a>
            </p>
          </div>
          -->

          <h4>Pond Village letter</h4>
          <p class="mt-2">
            Please bear with us as our Water Protector volunteers work to flesh out the details of this program.  We have more worthy programs than volunteer hours, so it takes a little time to get a new program up and going.  So please stay tuned.</p>
        </v-col>
      </v-row>

      <v-row>
        <v-btn
          small
          class="mr-2 small"
          @click="wpClick"
        >
          Back to Water Protectors<span class="hidden-md-and-down">...</span>
        </v-btn>
      </v-row>

      <v-row>
        <v-btn
          small
          class="mr-2 small"
          @click="zbaClick"
        >
          ZBA letter<span class="hidden-md-and-down">...</span>
        </v-btn>
      </v-row>
    </v-container>
  </section>
</template>

<script>
  export default {

    components: {
      // ToolbarWq: () => import('@/views/projects/ToolbarWq'),
    },

    name: 'Adapt',

    data: () => ({
      // maxW: 800,
      youTube: false,
    }),

    methods: {

      wpClick: function (event) {
        this.$router.push({ name: 'splashWQ' })
      },

      zbaClick: function (event) {
        this.$router.push({ name: 'PondVillage' })
      },

    },

  }
</script>
